import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicServerTemplateListParamsRaw,
	type LWApiPublicServerTemplateListResultRaw,
} from '@liquidweb-dev/club-sauce/public/server/template/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SERVER_TEMPLATE_LIST_QUERY_KEY = '/server/template/list';

const useServerTemplateList = (
	params: LWApiPublicServerTemplateListParamsRaw,
	options?: UseQueryOptions<LWApiPublicServerTemplateListResultRaw, ApiErrorI>,
) =>
	useQuery({
		queryKey: [SERVER_TEMPLATE_LIST_QUERY_KEY, params],
		queryFn: () => api.server.template.apiRaw.list(params),
		...options,
	});

export default useServerTemplateList;
